import { withJsonFormsControlProps } from '@jsonforms/react'

// seperate form/page element
import {
  PageAutocompleteDisplay,
  autocompleteTester,
} from '../element/Autocomplete'
import { PageCheckboxDisplay, checkboxTester } from '../element/Checkbox'
import {
  PageCheckboxGroupDisplay,
  checkboxGroupTester,
} from '../element/CheckboxGroup'
import {
  PageCheckboxInputDisplay,
  checkboxInputTester,
} from '../element/CheckboxInput'
import { PageDateDisplay, dateTester } from '../element/Date'
import { PageDateTimeDisplay, dateTimeTester } from '../element/DateTime'
import { PageInputDisplay, inputTester } from '../element/Input'
import {
  PageInputSearchDisplay,
  inputSearchTester,
} from '../element/InputSearch'
import { PageInputMaskDisplay, inputMaskTester } from '../element/InputMask'
import { PageNumberDisplay, numberTester } from '../element/Number'
import { PageRadioDisplay, radioTester } from '../element/Radio'
import { PageSelectDisplay, selectTester } from '../element/Select'
import { PageTableDisplay, tableTester } from '../element/Table'
import { PageCustomTableDisplay, customTableTester } from '../element/CustomTable'
import { PageTextareaDisplay, textareaTester } from '../element/Textarea'
import { PageTimeDisplay, timeTester } from '../element/Time'

// default element
import { RichTextDisplay, richTextTester } from '../element/RichText'
import {
  ButtonDisplay,
  ButtonDropdownDisplay,
  buttonTester,
  buttonDropdownTester,
} from '../element/Button'
import {
  FavoriteButtonDisplay,
  favoriteButtonTester,
} from '../element/FavoriteButton'
import { DividerDisplay, dividerTester } from '../element/Divider'
import { ElementDisplay, elementTester } from '../element/Element'
import { FileUploadDisplay, fileUploadTester } from '../element/FileUpload'
import { ImageDisplay, imageTester } from '../element/Image'
import {
  ImageCropperDisplay,
  imageCropperTester,
} from '../element/ImageCropper'
import { ImageWebcamDisplay, imageWebcamTester } from '../element/ImageWebcam'
import { VideoDisplay, videoTester } from '../element/Video'
import { VideoWebcamDisplay, videoWebcamTester } from '../element/VideoWebcam'
import { BadgeDisplay, badgeTester } from '../element/Badge'
import { ScoreChartDisplay, scoreChartTester } from '../element/ScoreChart'
import { LabelDisplay, labelTester } from '../element/Label'
import { GalleryDisplay, galleryTester } from '../element/Gallery'
import { ListDisplay, listTester } from '../element/List'
import { ColorPickerDisplay, colorPickerTester } from '../element/ColorPicker'

const formElement = [
  {
    tester: autocompleteTester,
    renderer: withJsonFormsControlProps(PageAutocompleteDisplay),
  },
  {
    tester: checkboxTester,
    renderer: withJsonFormsControlProps(PageCheckboxDisplay),
  },
  {
    tester: checkboxGroupTester,
    renderer: withJsonFormsControlProps(PageCheckboxGroupDisplay),
  },
  {
    tester: checkboxInputTester,
    renderer: withJsonFormsControlProps(PageCheckboxInputDisplay),
  },
  {
    tester: dateTester,
    renderer: withJsonFormsControlProps(PageDateDisplay),
  },
  {
    tester: dateTimeTester,
    renderer: withJsonFormsControlProps(PageDateTimeDisplay),
  },
  {
    tester: inputTester,
    renderer: withJsonFormsControlProps(PageInputDisplay),
  },
  {
    tester: inputSearchTester,
    renderer: withJsonFormsControlProps(PageInputSearchDisplay),
  },
  {
    tester: inputMaskTester,
    renderer: withJsonFormsControlProps(PageInputMaskDisplay),
  },
  {
    tester: numberTester,
    renderer: withJsonFormsControlProps(PageNumberDisplay),
  },
  {
    tester: radioTester,
    renderer: withJsonFormsControlProps(PageRadioDisplay),
  },
  {
    tester: selectTester,
    renderer: withJsonFormsControlProps(PageSelectDisplay),
  },
  {
    tester: textareaTester,
    renderer: withJsonFormsControlProps(PageTextareaDisplay),
  },
  {
    tester: timeTester,
    renderer: withJsonFormsControlProps(PageTimeDisplay),
  },
  {
    tester: tableTester,
    renderer: withJsonFormsControlProps(PageTableDisplay),
  },
]

const defaultElement = [
  {
    tester: richTextTester,
    renderer: withJsonFormsControlProps(RichTextDisplay),
  },
  {
    tester: buttonTester,
    renderer: withJsonFormsControlProps(ButtonDisplay),
  },
  {
    tester: buttonDropdownTester,
    renderer: withJsonFormsControlProps(ButtonDropdownDisplay),
  },
  {
    tester: favoriteButtonTester,
    renderer: withJsonFormsControlProps(FavoriteButtonDisplay),
  },
  {
    tester: dividerTester,
    renderer: withJsonFormsControlProps(DividerDisplay),
  },
  {
    tester: elementTester,
    renderer: withJsonFormsControlProps(ElementDisplay),
  },
  {
    tester: fileUploadTester,
    renderer: withJsonFormsControlProps(FileUploadDisplay),
  },
  {
    tester: imageTester,
    renderer: withJsonFormsControlProps(ImageDisplay),
  },
  {
    tester: imageCropperTester,
    renderer: withJsonFormsControlProps(ImageCropperDisplay),
  },
  {
    tester: imageWebcamTester,
    renderer: withJsonFormsControlProps(ImageWebcamDisplay),
  },
  {
    tester: videoTester,
    renderer: withJsonFormsControlProps(VideoDisplay),
  },
  {
    tester: videoWebcamTester,
    renderer: withJsonFormsControlProps(VideoWebcamDisplay),
  },
  {
    tester: badgeTester,
    renderer: withJsonFormsControlProps(BadgeDisplay),
  },
  {
    tester: scoreChartTester,
    renderer: withJsonFormsControlProps(ScoreChartDisplay),
  },
  {
    tester: labelTester,
    renderer: withJsonFormsControlProps(LabelDisplay),
  },
  {
    tester: listTester,
    renderer: withJsonFormsControlProps(ListDisplay),
  },
  {
    tester: colorPickerTester,
    renderer: withJsonFormsControlProps(ColorPickerDisplay),
  },
]

export const pageElementDisplay = [...defaultElement, ...formElement]

export const elementDisplayRenderer = {
  autocomplete: {
    tester: autocompleteTester,
    renderer: withJsonFormsControlProps(PageAutocompleteDisplay),
  },
  checkbox: {
    tester: checkboxTester,
    renderer: withJsonFormsControlProps(PageCheckboxDisplay),
  },
  checkboxGroup: {
    tester: checkboxGroupTester,
    renderer: withJsonFormsControlProps(PageCheckboxGroupDisplay),
  },
  checkboxInput: {
    tester: checkboxInputTester,
    renderer: withJsonFormsControlProps(PageCheckboxInputDisplay),
  },
  date: {
    tester: dateTester,
    renderer: withJsonFormsControlProps(PageDateDisplay),
  },
  dateTime: {
    tester: dateTimeTester,
    renderer: withJsonFormsControlProps(PageDateTimeDisplay),
  },
  input: {
    tester: inputTester,
    renderer: withJsonFormsControlProps(PageInputDisplay),
  },
  inputSearch: {
    tester: inputSearchTester,
    renderer: withJsonFormsControlProps(PageInputSearchDisplay),
  },
  inputMask: {
    tester: inputMaskTester,
    renderer: withJsonFormsControlProps(PageInputMaskDisplay),
  },
  number: {
    tester: numberTester,
    renderer: withJsonFormsControlProps(PageNumberDisplay),
  },
  radio: {
    tester: radioTester,
    renderer: withJsonFormsControlProps(PageRadioDisplay),
  },
  select: {
    tester: selectTester,
    renderer: withJsonFormsControlProps(PageSelectDisplay),
  },
  textarea: {
    tester: textareaTester,
    renderer: withJsonFormsControlProps(PageTextareaDisplay),
  },
  time: {
    tester: timeTester,
    renderer: withJsonFormsControlProps(PageTimeDisplay),
  },
  table: {
    tester: tableTester,
    renderer: withJsonFormsControlProps(PageTableDisplay),
  },
  customTable: {
    tester: customTableTester,
    renderer: withJsonFormsControlProps(PageCustomTableDisplay),
  },
  customTable: {
    tester: customTableTester,
    renderer: withJsonFormsControlProps(PageCustomTableDisplay),
  },
  richtext: {
    tester: richTextTester,
    renderer: withJsonFormsControlProps(RichTextDisplay),
  },
  button: {
    tester: buttonTester,
    renderer: withJsonFormsControlProps(ButtonDisplay),
  },
  buttonDropdown: {
    tester: buttonDropdownTester,
    renderer: withJsonFormsControlProps(ButtonDropdownDisplay),
  },
  favoriteButton: {
    tester: favoriteButtonTester,
    renderer: withJsonFormsControlProps(FavoriteButtonDisplay),
  },
  divider: {
    tester: dividerTester,
    renderer: withJsonFormsControlProps(DividerDisplay),
  },
  element: {
    tester: elementTester,
    renderer: withJsonFormsControlProps(ElementDisplay),
  },
  fileUpload: {
    tester: fileUploadTester,
    renderer: withJsonFormsControlProps(FileUploadDisplay),
  },
  image: {
    tester: imageTester,
    renderer: withJsonFormsControlProps(ImageDisplay),
  },
  imageCropper: {
    tester: imageCropperTester,
    renderer: withJsonFormsControlProps(ImageCropperDisplay),
  },
  imageWebcam: {
    tester: imageWebcamTester,
    renderer: withJsonFormsControlProps(ImageWebcamDisplay),
  },
  video: {
    tester: videoTester,
    renderer: withJsonFormsControlProps(VideoDisplay),
  },
  videoWebcam: {
    tester: videoWebcamTester,
    renderer: withJsonFormsControlProps(VideoWebcamDisplay),
  },
  badge: {
    tester: badgeTester,
    renderer: withJsonFormsControlProps(BadgeDisplay),
  },
  scoreChart: {
    tester: scoreChartTester,
    renderer: withJsonFormsControlProps(ScoreChartDisplay),
  },
  label: {
    tester: labelTester,
    renderer: withJsonFormsControlProps(LabelDisplay),
  },
  gallery: {
    tester: galleryTester,
    renderer: withJsonFormsControlProps(GalleryDisplay),
  },
  list: {
    tester: listTester,
    renderer: withJsonFormsControlProps(ListDisplay),
  },
  colorPicker: {
    tester: colorPickerTester,
    renderer: withJsonFormsControlProps(ColorPickerDisplay),
  },
}
